import * as PIXI from "pixi.js";

const DEFAULT_TEXTURE_MAP = {
    "0": "0", "1": "1", "2": "2", "3": "3", "4": "4",
    "5": "5", "6": "6", "7": "7", "8": "8", "9": "9",
  ".": "dot",
    "x": "x",
};

export class ImageNumbers extends PIXI.Container {
    constructor({ resources, textureMap, size = null }) {
        super();
        this._resources = resources;
        this._textureMap = textureMap ?? DEFAULT_TEXTURE_MAP;
        this._size = size;      // целевая высота глифа или null (натуральный размер)
        this._value = null;     // последнее значение для перерисовки в setSize
        this._decimals = 2;
    }

    setSize(size) {
        this._size = size;
        if (this._value !== null) this.setValue(this._value, this._decimals);
    }

    setValue(value, decimals = 2) {
        this._value = value;
        this._decimals = decimals;

        const str = typeof value === "number"
            ? value.toFixed(decimals)
            : String(value);

        this.removeChildren();

        let x = 0;
        for (const ch of str) {
            const alias = this._textureMap[ch];
            if (!alias) continue;
            const tex = this._resources.get(alias);
            if (!tex) {
                console.warn(`[ImageNumbers] texture not found for alias "${alias}"`);
                continue;
            }
            const sprite = new PIXI.Sprite(tex);
            if (this._size != null && tex.height > 0) {
                sprite.scale.set(this._size / tex.height);
            }
            sprite.x = x;
            x += sprite.width;
            this.addChild(sprite);
        }

        this.pivot.x = x / 2;
    }
}
